import { service } from '@ember/service';
import { Ability } from 'ember-can';
import { isProductDisabled } from 'garaje/helpers/product-disabled';
import type AuthzService from 'garaje/services/authz';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';
import { Permission } from 'garaje/utils/ui-permissions';

export default class EmployeeGroupAbility extends Ability {
  @service declare authz: AuthzService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare state: StateService;

  get canVisitGlobal(): boolean {
    // BLAM-564 deletes this line at GA. Everything below it stays.
    if (!this.featureFlags.isEnabled('blam-assigned-employee-group')) return false;
    if (!this.#canAddressEmployees) return false;
    return this.#canReadEmployees;
  }

  /**
   * A Group is only usable where Response can address employees: the audience pair
   * `communications-service.showEmployeeSelect` reads, plus the parent that makes its pages reachable.
   */
  get #canAddressEmployees(): boolean {
    if (isProductDisabled('communications')) return false;
    const features = this.state.features;
    if (!features) return false;
    if (!features.canAccessEmergencyNotifications) return false;
    if (features.canAccessEmergencyNotificationsEmployees) return true;
    return !!features.canAccessEmergencyNotificationsEmployeesAtLocation;
  }

  /** No dedicated authz permission exists for groups, so this reuses employee-directory read access. */
  get #canReadEmployees(): boolean {
    return this.authz.hasPermissionAtCurrentCompany(Permission.USER_MANAGEMENT_EMPLOYEE_READ);
  }
}
